import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Switch, Button, DatePicker } from "antd";
import { ExpandOutlined, MoreOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { TextArea } = Input;

const ApiKeyFormDrawer = ({
  open,
  onClose,
  onSubmit,
  mode = "create",
  initialValues = null,
  loading,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    if (mode === "edit" && initialValues) {
      form.setFieldsValue({
        ...initialValues,
        expiresAt: initialValues?.expiresAt
          ? dayjs(initialValues.expiresAt)
          : null,
      });
    } else {
        form.resetFields();
        form.setFieldsValue({
          active: true,
        });
    }
  }, [open, mode, initialValues, form]);

  const handleFinish = (values) => {
    const payload = {
      ...values,
      expiresAt: values.expiresAt ? values.expiresAt.toISOString() : null,
    };

    onSubmit(payload);

    if (mode === "create") {
      form.resetFields();
    }
  };

  return (
    <Drawer
      zIndex={99999}
      placement="right"
      closable={false}
      size={isExpanded ? 520 : "100vw"}
      onClose={onClose}
      open={open}
      destroyOnHidden
      footer={
        <div
          style={{
            textAlign: "right",
            maxWidth: isExpanded ? "100vw" : 700,
            margin: isExpanded ? 0 : "0 auto",
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <Button style={{ marginRight: 8 }} onClick={onClose}>
            Close
          </Button>
          <Button
            type="primary"
            onClick={() => form.submit()}
            loading={loading}
          >
            {mode === "edit" ? "Save Changes" : "Create API Key"}
          </Button>
        </div>
      }
    >
      <div
        style={{
          maxWidth: isExpanded ? "100vw" : 700,
          margin: isExpanded ? 0 : "0 auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <div style={{ fontSize: 15, color: "#6b7280", fontFamily: "Inter" }}>
            <span>API Keys</span>
            <span style={{ margin: "0 6px" }}>/</span>
            <span style={{ color: "#111827", fontWeight: 500 }}>
              {mode === "edit" ? "Edit API Key" : "Create API Key"}
            </span>
          </div>

          <div style={{ display: "flex", gap: 16 }}>
            <ExpandOutlined
              onClick={() => setIsExpanded((prev) => !prev)}
              style={{ cursor: "pointer" }}
            />
            <MoreOutlined style={{ cursor: "pointer" }} />
          </div>
        </div>

        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
        >
          {/* Client ID */}
          <Form.Item
            label="Client ID (UUID)"
            name="clientId"
            rules={[{ required: true, message: "Client ID is required" }]}
          >
            <Input
              placeholder="e.g. 550e8400-e29b-41d4-a716-446655440000"
              disabled={mode === "edit"}
            />
          </Form.Item>

          {/* API Key */}
          <Form.Item
            label="API Key"
            name="key"
            rules={[{ required: true, message: "API Key is required" }]}
          >
            <Input
              placeholder="Enter unique API key value"
              disabled={mode === "edit"}
            />
          </Form.Item>

          {/* Name */}
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Name is required" }]}
          >
            <Input placeholder="e.g. Payment Gateway Key" />
          </Form.Item>

          {/* Description */}
          <Form.Item label="Description" name="description">
            <TextArea
              rows={4}
              placeholder="Describe what this key is used for..."
            />
          </Form.Item>

          {/* Expiration */}
          <Form.Item label="Expiration Date" name="expiresAt">
            <DatePicker style={{ width: "100%" }} showTime />
          </Form.Item>

          {/* Active */}
          <Form.Item label="Active" name="active" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </div>
    </Drawer>
  );
};

export default ApiKeyFormDrawer;
